import React from 'react'
import 'antd/lib/switch/style/index.css'
import {
	Row, Col, Tooltip
}from 'antd'
import '../style.css'
import moment from "moment"
import AdditionalOrderMessageFiles from '../../AppealFiles/AdditionalOrderMessageFiles'
import SignedIcon from "../../../../../public/signedIcon.png"
import i18n from './localization'

const AdditionalOrderMessage = (props) => {
	const {
		additionalOrderMessage, reOrgAppealStatusCode, isRu, key, showSignerInfo
	} = props

	return (
        <Row
        className="result-appeal"
        justify="center"
        key={key}
        >
        <Col className="header-result-appeal">
            <span className='header-result'>
                <span className='header-title'>
                    { i18n.ReviewResultWithDate[isRu].format(moment(additionalOrderMessage.creationDate).format("DD.MM.YYYY"))}
                </span>
                <span>
                    {additionalOrderMessage.signerInfo && showSignerInfo &&
                        <Tooltip 
                            title={i18n.signer[isRu].format(additionalOrderMessage.signerInfo)}
                            overlayInnerStyle={{ whiteSpace: 'pre-line' }}
                            className='signed_icon'
                        >
                            <img src={SignedIcon} />
                        </Tooltip>
                    }
                </span>
            </span>
        </Col>
        <Col className="body-result-appeal">
                { `\t${additionalOrderMessage.responseForApplicant}`}
        </Col>
        <Col>
            { 
                ["13","14"].includes(reOrgAppealStatusCode) &&
                <>
                    <Row>
                        { additionalOrderMessage.answerRegNumber ? `${i18n.AnswerRegNumber[isRu]}: ${additionalOrderMessage.answerRegNumber }` : null}
                    </Row>
                    <Row>
                        { additionalOrderMessage.caseNumber ? `${ i18n.CaseNumber[isRu] }: ${additionalOrderMessage.caseNumber}` : null}
                    </Row>
                </>
            }
        </Col>
        <Col className="files-body-info-appeal">
            <AdditionalOrderMessageFiles
                isRu={ isRu }
                additionalOrderMessageFiles = {additionalOrderMessage.additionalOrderMessageFiles}
                additionalOrderMessageId = {additionalOrderMessage.id}
                additionalOrderMessageDate = { moment(additionalOrderMessage.creationDate).format("DD.MM.YYYY")}
                showSignerInfo = {showSignerInfo}
            /> 
        </Col>
    </Row>
    )
}

export default AdditionalOrderMessage
